import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';


import { useSelector, useDispatch } from 'react-redux';


import {
  updateCategories,
  updateAllCategories
} from 'store/actions/restaurantMenu';
import { moveMenuItemToCategory } from './moveMenuItem';

export default function MoveCategoryDialog(props) {
  const {open, selectedMenuItem, closeHandler} = props;
  const dispatch = useDispatch();
  const [value, setValue] = useState(null);
  const [uiLoading, setUiLoading] = useState(false);
  
  const categories = useSelector((state) => state.restaurantMenu.menuCategories);
  const updateTheAllCategories = (allCategories) => dispatch(updateAllCategories(allCategories));
  const updateNewCategories = (newCategories) => dispatch(updateCategories(newCategories));
  

  const handleClose = () => {
    closeHandler();
  };

 const handleMenuItemMove =  () => {
  const newCategories = moveMenuItemToCategory(categories, selectedMenuItem, value.id);
  if (!newCategories) {
    // Same category as now: nothing to move.
    closeHandler();
    return;
  }

  updateNewCategories(newCategories);
  updateTheAllCategories({ menuId: selectedMenuItem.menuId, categories: newCategories });
  closeHandler();
  
     
 };


  return (
    <div>
    
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Select a category to move to</DialogTitle>
        <DialogContent>
        
        <Autocomplete
      id="categoryId"
      options={categories}
      getOptionLabel={(option) => option.name}
      style={{ minWidth: 300 }}

      value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
  
      renderInput={(params) => <TextField {...params} label="Category" variant="outlined" />}
    />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleMenuItemMove} 
          disabled={uiLoading || !value}
           color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
